import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home/page'));
const TarifsPage = lazy(() => import('../pages/tarifs/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Legal pages
const MentionsLegales = lazy(() => import('../pages/legal/MentionsLegales'));
const PolitiqueConfidentialite = lazy(() => import('../pages/legal/PolitiqueConfidentialite'));
const PolitiqueCookies = lazy(() => import('../pages/legal/PolitiqueCookies'));
const AssuranceCertifications = lazy(() => import('../pages/legal/AssuranceCertifications'));

// Villes pages
const Colomiers = lazy(() => import('../pages/villes/Colomiers'));
const Blagnac = lazy(() => import('../pages/villes/Blagnac'));
const Tournefeuille = lazy(() => import('../pages/villes/Tournefeuille'));
const Muret = lazy(() => import('../pages/villes/Muret'));
const Balma = lazy(() => import('../pages/villes/Balma'));
const Ramonville = lazy(() => import('../pages/villes/Ramonville'));
const Cugnaux = lazy(() => import('../pages/villes/Cugnaux'));
const SaintGaudens = lazy(() => import('../pages/villes/SaintGaudens'));
const LUnion = lazy(() => import('../pages/villes/LUnion'));
const PlaisanceDuTouch = lazy(() => import('../pages/villes/PlaisanceDuTouch'));
const SaintOrens = lazy(() => import('../pages/villes/SaintOrens'));
const Portet = lazy(() => import('../pages/villes/Portet'));
const Auterive = lazy(() => import('../pages/villes/Auterive'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/tarifs',
    element: <TarifsPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegales />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialite />,
  },
  {
    path: '/politique-cookies',
    element: <PolitiqueCookies />,
  },
  {
    path: '/assurance-certifications',
    element: <AssuranceCertifications />,
  },
  {
    path: '/colomiers',
    element: <Colomiers />,
  },
  {
    path: '/blagnac',
    element: <Blagnac />,
  },
  {
    path: '/tournefeuille',
    element: <Tournefeuille />,
  },
  {
    path: '/muret',
    element: <Muret />,
  },
  {
    path: '/balma',
    element: <Balma />,
  },
  {
    path: '/ramonville',
    element: <Ramonville />,
  },
  {
    path: '/cugnaux',
    element: <Cugnaux />,
  },
  {
    path: '/saint-gaudens',
    element: <SaintGaudens />,
  },
  {
    path: '/lunion',
    element: <LUnion />,
  },
  {
    path: '/plaisance-du-touch',
    element: <PlaisanceDuTouch />,
  },
  {
    path: '/saint-orens',
    element: <SaintOrens />,
  },
  {
    path: '/portet-sur-garonne',
    element: <Portet />,
  },
  {
    path: '/auterive',
    element: <Auterive />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
